import React, { useState } from "react";
import Widget from "./Widget";

function CareerInfo({ career, image }) {
	const [tab, setTab] = useState("overview");

  if (!career) {
    return <p>¡Carrera no encontrada!</p>;
  }

  return (
		<div class="container">
			<div class="row">
			
				<div class="col-xl-8 col-lg-8 col-md-12 pe-xl-5">
					<div class="tab_box_info">
						<ul class="nav nav-pills mb-2 light" id="pills-tab" role="tablist">
							<li class="nav-item">
								{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
								<a class={`nav-link ${tab === "overview" ? "active" : ""}`} id="overview-tab"
								onClick={() => setTab("overview")} href="#"
								role="tab" aria-controls="overview" aria-selected={tab === "overview"}>Resumen</a>
							</li>
							{career.fieldsOfWork.length > 0 && (
								<li class="nav-item mx-2">
									{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
									<a class={`nav-link ${tab === "employment" ? "active" : ""}`} id="employment-tab" role="tab" href="#"
										onClick={() => setTab("employment")} aria-controls="employment" aria-selected={tab === "employment"}>Factores de empleabilidad</a>
								</li>
							)}
							{career.continuationOfStudies && (
								<li class="nav-item">
									{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
									<a class={`nav-link ${tab === "continuation" ? "active" : ""}`} id="continuation-tab" role="tab"
									onClick={() => setTab("continuation")} href="#"
									aria-controls="continuation" aria-selected={tab === "continuation"}>Continuación de Estudios</a>
								</li>
							)}
							{career.pensum && (
								<li class="nav-item">
									{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
									<a class={`nav-link ${tab === "pensum" ? "active" : ""}`} id="pensum-tab" role="tab"
										onClick={() => setTab("pensum")} href="#" aria-controls="pensum" aria-selected={tab === "pensum"}>Pensum</a>
								</li>
							)}
						</ul>
					
						<div class="tab-content" id="pills-tabContent">									
							<div class={`tab-pane fade ${tab === "overview" ? "show active" : ""}`} id="overview" role="tabpanel" aria-labelledby="overview-tab">
								<div class="edu_wraper">
									<h4 class="edu_title">{career.name}</h4>
									<p>{career.overview}</p>

									{career.slogan && (
										<div class="slogan-block mt-4">
											<p style={{ fontStyle: 'italic'}}>{career.slogan}</p>
										</div>
									)	}
									
									{career.graduateProfile.length > 0 && (
										<div class="who-enrolled-block mt-4">
											<h5 class="edu_title mb-2">Perfil de la carrera</h5>

											{ career.graduateProfile.length === 1 && (
													<p>{career.graduateProfile[0]}</p>
												)
											}
											{career.graduateProfile.length > 1 && (
												<div class="features-list">
													{career.graduateProfile.map((item, index) => (
														<li key={index}><i class="bi bi-check-circle"></i>
															{item}
														</li>
													))}
												</div>
											)}

											{career.fieldsOfWork.length > 0 && (
												<div class="who-enrolled-block mt-4">
													<h5 class="edu_title mb-2">Campos de trabajo</h5>

													{ career.fieldsOfWork.length === 1 && (
															<p>{career.fieldsOfWork[0]}</p>
														)
													}
													{career.fieldsOfWork.length > 1 && (
														<div class="features-list">
															{career.fieldsOfWork.map((item, index) => (
																<li key={index}><i class="bi bi-check-circle"></i>
																	{item}
																</li>
															))}
														</div>
													)}
												</div>
											)}
										</div>
									)}

								</div>
							</div>
							<div class={`tab-pane fade ${tab === "employment" ? "show active" : ""}`} id="employment" role="tabpanel" aria-labelledby="employment-tab">
								<div class="edu_wraper">
									{career.employmentFactors.length > 0 && (
										<div class="who-enrolled-block">
											<h5 class="edu_title mb-2">Factores de empleabilidad</h5>

											{ career.employmentFactors.length === 1 && (
													<p>{career.employmentFactors[0]}</p>
												)
											}
											{career.employmentFactors.length > 1 && (
												<div class="features-list">
													{career.employmentFactors.map((item, index) => (
														<li key={index}><i class="bi bi-check-circle"></i>
															{item}
														</li>
													))}
												</div>
											)}
										</div>
									)}
								</div>
							</div>

							<div class={`tab-pane fade ${tab === "continuation" ? "show active" : ""}`} id="continuation" role="tabpanel" aria-labelledby="continuation-tab">
								<div class="edu_wraper">
									{career.continuationOfStudies && (
										<div class="who-enrolled-block">
											<h5 class="edu_title mb-2">Continuación de Estudios</h5>
											<p>{career.continuationOfStudies}</p>
										</div>
									)}
								</div>
							</div>
							
						</div>
					</div>
					
				</div>
				
				<Widget career={career} image={image} />
			</div>
		</div>
  );
}

export default CareerInfo;